import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "client-info"
}
const _hoisted_2 = { class: "client-info__header" }
const _hoisted_3 = { class: "client-info__header-left" }
const _hoisted_4 = { class: "client-info__field" }
const _hoisted_5 = { class: "client-info__field-name" }
const _hoisted_6 = { class: "client-info__field-value" }
const _hoisted_7 = { class: "client-info__field" }
const _hoisted_8 = { class: "client-info__field-name" }
const _hoisted_9 = { class: "client-info__field-value" }
const _hoisted_10 = {
  key: 0,
  class: "client-info__field-value"
}
const _hoisted_11 = { class: "client-info__field" }
const _hoisted_12 = { class: "client-info__field-name" }
const _hoisted_13 = { class: "client-info__field-value" }
const _hoisted_14 = {
  key: 0,
  class: "client-info__field-value"
}
const _hoisted_15 = {
  key: 0,
  class: "client-info__field"
}
const _hoisted_16 = { class: "client-info__field-name" }
const _hoisted_17 = { class: "client-info__field-value" }
const _hoisted_18 = { class: "client-info__header-right" }
const _hoisted_19 = { class: "client-info__records" }
const _hoisted_20 = {
  key: 0,
  class: "client-info__field client-info__field--col"
}
const _hoisted_21 = { class: "client-info__field-name" }
const _hoisted_22 = { class: "client-info__field-value-col-time" }
const _hoisted_23 = { class: "client-info__field-value-col-action" }
const _hoisted_24 = {
  key: 1,
  class: "client-info__field client-info__field--col"
}
const _hoisted_25 = { class: "client-info__field-name" }
const _hoisted_26 = { class: "client-info__field-value-col-time" }
const _hoisted_27 = { class: "client-info__field-value-col-action" }
const _hoisted_28 = {
  key: 2,
  class: "client-info__field client-info__field--col"
}
const _hoisted_29 = { class: "client-info__field-name" }
const _hoisted_30 = { class: "client-info__field-value-col-time" }
const _hoisted_31 = { class: "client-info__field-value-col-action" }
const _hoisted_32 = { class: "client-info__field-value-col-person" }
const _hoisted_33 = {
  key: 3,
  class: "client-info__field client-info__field--col"
}
const _hoisted_34 = { class: "client-info__field-name" }
const _hoisted_35 = { class: "client-info__field-value-col-time" }
const _hoisted_36 = { class: "client-info__field-value-col-union" }

import {
	computed,
	onMounted,
	onUnmounted,
	ref,
	watch
} from "vue";
import { i18n } from "@/i18n";

import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
// import ClientAccessRulesTab from "./ClientAccessRulesTab.vue";
import MainPermitionsTab from "@/components/permitions/MainPermitionsTab.vue";
import ClientRules from "./ClientRules.vue";
import { ClientsApi } from "@/ api/ClientsApi";
import { AccessApi } from "@/ api/AccessApi";
import type { ClientInfoFull, AttachedEntityInChangeRecord } from "@/models/interfaces/client/client-info";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { clientPageStore } from "@/store/client-page";
import { workerStore } from "@/store/worker";

const CLIENT_SEGMENT = 1;


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientInfoModal',
  setup(__props, { expose: __expose }) {

const t = (key: string): string => String(i18n.global.t(key));
const route = useRoute();
const clientPage = clientPageStore();
const worker = workerStore();
const canEditRules = computed(() =>
	!!worker.workerProfile?.IsAdmin || clientPage.client?.RuleAccess === 1
);

// const tabs = clientPage.client?.RuleAccess == 1 ? [
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// 	{ id: 1, title: t("file_access_rights"), slotName: "rules" },
// ] : [
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// ];
const tabs = computed(() =>
  clientPage.client?.RuleAccess == 1
    ? [
        { id: 0, title: t("project_info_title"), slotName: "info" },
        { id: 1, title: t("file_access_rights"), slotName: "rules" },
      ]
    : [
        { id: 0, title: t("project_info_title"), slotName: "info" },
      ]
)

// const tabs = [ { id: 0, title: "Информация о клиенте", slotName: "info" },
// 	{ id: 1, title: "Права доступа", slotName: "rules" },
// ];

const $modal = ref<typeof BaseModal | null>(null);
const isActive = ref(false);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);

const activeTab = ref<number>(0);
const isLoading = ref(false);
const clientInfo = ref<ClientInfoFull | null>(null);
const rulesContainer = ref<EntityRulesContainer | null>(null);
const clientIdRef = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
	if (!date) return "";
	return moment(date).format("HH:mm DD.MM.YYYY");
};

const namesOf = (items?: AttachedEntityInChangeRecord[]) =>
	(items ?? []).map((i) => i.Name).join(", ");

watch(activeTab, () => {
	$lists.value?.close();
});

const refreshRules = async () => {
	try {
		const rulesGiver = await AccessApi.getClientAccessRules(clientIdRef.value);
		rulesContainer.value = rulesGiver?.Container ?? null;
	} catch (e) {
		console.error(e);
	}
};

const onOpen = async (clientId: number, clientTags: CommonEntityRecord[] = []) => {
	try {
		clientIdRef.value = clientId;
		tags.value = clientTags;
		isLoading.value = true;
		activeTab.value = 0;
		clientInfo.value = null;
		rulesContainer.value = null;
		$modal.value?.onOpen();
		isActive.value = true;

		const [infoGiver, rulesGiver] = await Promise.all([
			ClientsApi.getClientInfo(clientId),
			AccessApi.getClientAccessRules(clientId).catch((e) => {
				console.error(e);
				return null;
			}),
		]);

		clientInfo.value = infoGiver ?? null;
		rulesContainer.value = rulesGiver?.Container ?? null;
	} catch (e) {
		console.error(e);
	} finally {
		isLoading.value = false;
	}
};

const onClose = () => {
	isActive.value = false;
	$modal.value?.onClose();
}

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
		return;
  }
  if (document.querySelector('.app-select__dropdown')) {
    return;
  }
  if (!isActive.value) {
		return;
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    "fullscreen-on-mobile": "",
    onOnClose: _cache[2] || (_cache[2] = ($event: any) => (isActive.value = false)),
    loading: isLoading.value,
    width: "900px",
    height: "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(AppTabsOld, {
        tabs: tabs.value,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
      }, {
        info: _withCtx(() => [
          (!isLoading.value && clientInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('client_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(clientPage).client?.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('created_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(formatDate(clientInfo.value.CreateTime)), 1),
                      (clientInfo.value.Creator?.Name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " [" + _toDisplayString(clientInfo.value.Creator.Name) + "]", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('last_edit_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(clientInfo.value.ChangeTime)), 1),
                      (clientInfo.value.Changer?.Name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " [" + _toDisplayString(clientInfo.value.Changer.Name) + "]", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (tags.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('tags_upcase')) + ": ", 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(tags.value.map((t) => `#${t.Name}`).join(", ")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(AppLists, {
                      ref_key: "$lists",
                      ref: $lists,
                      modelValue: clientInfo.value.AnalyticsLists,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientInfo.value.AnalyticsLists) = $event)),
                      segment: CLIENT_SEGMENT,
                      "element-id": clientIdRef.value
                    }, null, 8, ["modelValue", "element-id"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (clientInfo.value.WorkerAttachmentLogs?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('users_and_roles_label')) + ": ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.WorkerAttachmentLogs, (log, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `w-${idx}`,
                            class: "client-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(log.CreatedAt)) + " ", 1),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(log.Message), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (clientInfo.value.ProjectChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('projects_label')) + ": ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.ProjectChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `p-${idx}`,
                            class: "client-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(formatDate(r.RecordDate)) + " ", 1),
                            _createElementVNode("span", _hoisted_27, " [" + _toDisplayString(r.Author?.Name) + "] " + _toDisplayString(_ctx.$t(r.RecordType === 0 ? 'record_added' : 'record_removed')) + "  ", 1),
                            (r.Object)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "client-info__field-value-col-link",
                                  to: { query: { page: 'project', id: r.Object.Id } }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(r.Object.Name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (clientInfo.value.PersonChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('contacts_label')) + ": ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.PersonChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `c-${idx}`,
                            class: "client-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(formatDate(r.RecordDate)) + " ", 1),
                            _createElementVNode("span", _hoisted_31, " [" + _toDisplayString(r.Author?.Name) + "] " + _toDisplayString(_ctx.$t(r.RecordType === 0 ? 'record_added' : 'record_removed')) + "  ", 1),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(r.Object?.Name), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (clientInfo.value.UnionChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('holding')) + ": ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientInfo.value.UnionChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `u-${idx}`,
                            class: "client-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(formatDate(r.RecordDate)) + " ", 1),
                            _createElementVNode("span", _hoisted_36, [
                              _createTextVNode(" [" + _toDisplayString(r.Author?.Name) + "] ", 1),
                              (r.RecordType === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('holding_created', { names: namesOf(r.ChangedClients) })), 1)
                                  ], 64))
                                : (r.RecordType === 1)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('holding_client_added', { names: namesOf(r.ChangedClients), holding: namesOf(r.UnchangedClients) })), 1)
                                    ], 64))
                                  : (r.RecordType === 2)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('holding_client_removed', { names: namesOf(r.ChangedClients), holding: namesOf(r.UnchangedClients) })), 1)
                                      ], 64))
                                    : (r.RecordType === 3)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('holding_disbanded', { names: namesOf(r.ChangedClients) })), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        rules: _withCtx(() => [
          _createVNode(MainPermitionsTab, {
            container: rulesContainer.value,
            "entity-id": clientIdRef.value,
            "can-edit": canEditRules.value,
            onSave: onClose,
            onRefresh: refreshRules,
            onCancel: onClose,
            type: "client"
          }, null, 8, ["container", "entity-id", "can-edit"])
        ]),
        _: 1
      }, 8, ["tabs", "modelValue"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})